
//-------------- Event handling -------------- //

function stickyFilterBar() {
  var filterBarPosTopDefault = $('#filter-and-sort').offset().top; // Position when not sticky
  var headerHeight = $('header').outerHeight();
  var scrolled = $(window).scrollTop();
  $('#filter-and-sort').removeClass('sticky'); // Remove mobile sticky
  if( scrolled >= (filterBarPosTopDefault - headerHeight) ) { // If past top and menu open
    $('#filter-and-sort').addClass('sticky');
  } else {
    $('#filter-and-sort').removeClass('sticky');
  }
}
if ($('#filter-and-sort').length) {
  stickyFilterBar();
	$(window).scroll ( function() {	stickyFilterBar(); });
	$(window).resize ( function() {	stickyFilterBar(); });
}




// Filter drawer
// Open filter drawer
$('#filter-button').off().click( function() {
  $('#filter-drawer').addClass('active');
  $('#filter-drawer .drawer-header .close-btn').addClass('highlight'); // One-time highlight of close button (mobile only)
  handleFixedElements('hide');
});
// Select filter section (unless 'show-all-filters' class is present)
if (!$('#filter-drawer').hasClass('show-all-filters')) {
  var filterSectionSlideTime = 200;
  $('.filter-section > a').off().click( function() {
    var thisFilterSection = $(this).closest('.filter-section');
    // Open
    if (!thisFilterSection.hasClass('active')) {
      $('.filter-section').not(thisFilterSection).children('.inner').slideUp(filterSectionSlideTime);
      $('.filter-section').not(thisFilterSection).removeClass('active');
      thisFilterSection.children('.inner').slideDown(filterSectionSlideTime);
      thisFilterSection.addClass('active');
    }
    // Close
    else {
      thisFilterSection.children('.inner').slideUp(filterSectionSlideTime);
      thisFilterSection.removeClass('active');
    }
  });
}





// Sort dropdown
// Open sort dropdown
$('#sort-button').off().click( function() {
  $(this).siblings('.dropdown').toggleClass('active');
});
// Close sort dropdown with close button (mobile)
$('#sort-button').siblings('.dropdown').find('.close-btn').off().click( function() {
  $(this).closest('.dropdown').removeClass('active');
});
// Close product customise panel by clicking outside of panel (Desktop)
$('html').click(function(e) {
  if( (window.innerWidth > desktopBreakPoint) ) { // Desktop only
    var sortButton = $('#sort-button');
    var sortDropdown = sortButton.siblings('.dropdown');
    if (!sortButton.is(e.target) && sortDropdown.has(e.target).length === 0) {
      $(sortDropdown).removeClass('active');
    }
  }
});











// Define URL parts (for Collection page only, not Search)
var urlFull = window.location.href; // full URL

if (urlFull.indexOf('collections/') >= 0) {

  var urlRoot = urlFull.split('collections/')[0]; // up to and excluding /collections/...
  var currentCollection = urlFull.split('collections/')[1].split('/')[0].split('?')[0].split('&')[0].split('#')[0]; // term directly after /collections/




  //-------------- Sort -------------- //

  // Get sorting parameter
  var urlSortParam = '';
  if (urlFull.indexOf('?sort_by=') >= 1 ) {
    urlSortParam = urlFull.split('?sort_by=')[1].split('/')[0].split('?')[0].split('&')[0].split('#')[0]; // sorting parameter
    $('#sort-button').addClass('active'); // show active state on Sort button
  }

  // Define sort-parameters
  var sortDefault = '';
  var sortBestSelling = 'best-selling';
  var sortNewest = 'created-descending';
  var sortOldest = 'created-ascending';
  var sortHighestPrice = 'price-descending';
  var sortLowestPrice = 'price-ascending';

  // On load set current sort option
  if (urlSortParam == sortBestSelling) {
    $('.collection-sort-option[data-sort-type="best-selling"]').addClass('active');
    $('.sort-by-name').html(": Best Selling");
    $('.sort-filter-wrap ul li:nth-child(2)').addClass('active');
  } else if (urlSortParam == sortNewest) {
    $('.collection-sort-option[data-sort-type="created-descending"]').addClass('active');
    $('.sort-by-name').html(": Newest");
    $('.sort-filter-wrap ul li:nth-child(3)').addClass('active');
  } else if (urlSortParam == sortOldest) {
    $('.collection-sort-option[data-sort-type="created-ascending"]').addClass('active');
    $('.sort-by-name').html(": Oldest");
    $('.sort-filter-wrap ul li:nth-child(4)').addClass('active');
  } else if (urlSortParam == sortHighestPrice) {
    $('.collection-sort-option[data-sort-type="price-descending"]').addClass('active');
    $('.sort-by-name').html(": Price high to low");
    $('.sort-filter-wrap ul li:nth-child(5)').addClass('active');
  } else if (urlSortParam == sortLowestPrice) {
    $('.collection-sort-option[data-sort-type="price-ascending"]').addClass('active');
    $('.sort-by-name').html(": Price low to high");
    $('.sort-filter-wrap ul li:nth-child(6)').addClass('active');
  } else {
    $('.collection-sort-option[data-sort-type="default"]').addClass('active');
    $('.sort-by-name').html(": Recommended");
    $('.sort-filter-wrap ul li:nth-child(1)').addClass('active');
  }

  var urlSortString = '';
  if (urlSortParam !== '') {
    urlSortString = '?sort_by=' + urlSortParam;
  }

  // Click sort option
  $('.collection-sort-option').click( function() {
    // Change selected checkbox
    $(this).closest('ul').find('a').removeClass('active');
    $(this).addClass('active');
    // Go to new filtered URL
    var thisSortParam = $(this).attr('data-sort-type');
    if (thisSortParam == 'default') {
      urlSortString = '';
    } else {
      urlSortString = '?sort_by=' + thisSortParam;
    }
    window.location.href = urlRoot + 'collections/' + currentCollection + selectedTagsString + urlSortString;
  });







  //-------------- Filter -------------- //

  var urlAllTags = {};

  // Get Metal tag
  var urlMetalTag;
  if (urlFull.indexOf('metal:') >= 1 ) {
    urlMetalTag = 'metal:' + urlFull.split('metal:')[1].split('+')[0].split('?')[0];
    urlAllTags.metal = urlMetalTag; // Apply metal parameter to object
  }
  // Get Piece tag
  var urlPieceTag;
  if (urlFull.indexOf('piece:') >= 1 ) {
    urlPieceTag = 'piece:' + urlFull.split('piece:')[1].split('+')[0].split('?')[0];
    urlAllTags.piece = urlPieceTag; // Apply piece parameter to object
  }
  // Get Stone-type tag
  var urlStoneTypeTag;
  if (urlFull.indexOf('stone:type:') >= 1 ) {
    urlStoneTypeTag = 'stone:type:' + urlFull.split('stone:type:')[1].split('+')[0].split('?')[0];
    urlAllTags['stone:type'] = urlStoneTypeTag; // Apply stone-type parameter to object (bracket notation for hyphenated values)
  } else if (urlFull.indexOf('stone-type:') >= 1 ) {
    urlStoneTypeTag = 'stone-type:' + urlFull.split('stone-type:')[1].split('+')[0].split('?')[0];
    urlAllTags['stone:type'] = urlStoneTypeTag; // Apply stone-type parameter to object (bracket notation for hyphenated values)
  }
  // Get Stone-shape tag
  var urlStoneShapeTag;
  if (urlFull.indexOf('stone:shape:') >= 1) {
    urlStoneShapeTag = 'stone:shape:' + urlFull.split('stone:shape:')[1].split('+')[0].split('?')[0];
    urlAllTags['stone:shape'] = urlStoneShapeTag; // Apply stone-shape parameter to object (bracket notation for hyphenated values)
  } else if (urlFull.indexOf('stone-shape:') >= 1) {
    urlStoneShapeTag = 'stone-shape:' + urlFull.split('stone-shape:')[1].split('+')[0].split('?')[0];
    urlAllTags['stone:shape'] = urlStoneShapeTag; // Apply stone-shape parameter to object (bracket notation for hyphenated values)
  }
  // Get Stone-setting tag
  var urlStoneSettingTag;
  if (urlFull.indexOf('stone:setting:') >= 1) {
    urlStoneSettingTag = 'stone:setting:' + urlFull.split('stone:setting:')[1].split('+')[0].split('?')[0];
    urlAllTags['stone:setting'] = urlStoneSettingTag; // Apply stone-setting parameter to object (bracket notation for hyphenated values)
  }
  // Get Band tag
  var urlBandTag;
  if (urlFull.indexOf('band:') >= 1 ) {
    urlBandTag = 'band:' + urlFull.split('band:')[1].split('+')[0].split('?')[0];
    urlAllTags.band = urlBandTag; // Apply band parameter to object
  }

  // On Load:  Activate filter tags that are in URL
  function activateTagsFromUrl() {
    $.each(urlAllTags, function(filterSection, tag){
      $('.filter-option[data-tag="'+tag+'"]').parent('li').addClass('active');
      $('#filter-button').addClass('active'); // Show active state on Filter button
      $('#filter-clear').removeClass('disabled'); // Enable Clear button
      $('#collection-pagination').attr('data-filter-applied', true); // set attribute ot mark filter active
    });
    // // If no options checked in a section, check 'All' option
    $('.filter-section').each( function() {
      var thisFilterSection = $(this);
      if (!thisFilterSection.find('ul li.active').length) {
        thisFilterSection.find('.filter-option.all').parent('li').addClass('active');
      }
    });
  }
  activateTagsFromUrl(); // On load


  // On load: Create pills for all applied filters
  const createFilterPills = () => {
    const appliedFilters = document.getElementById('applied-filters');
    let appliedFilterPill = null;
    // Create pills
    Object.values(urlAllTags).forEach(tag => {
      let filterOption = document.querySelector(`.filter-option[data-tag="${tag}"]`);
      appliedFilterPill = document.createElement('span');
      appliedFilterPill.classList.add('pill', 'loading');
      appliedFilterPill.setAttribute('data-tag', tag);
      appliedFilterPill.innerHTML = `${filterOption.innerText}<button class="close-btn"></button>`;
      appliedFilters.append(appliedFilterPill);
    });
    let appliedFilterPills = appliedFilters.querySelectorAll('.pill');
    // For each pill...
    appliedFilterPills.forEach((pill,i) => {
      // Display pills in sequence
      setTimeout(() => {
        pill.classList.remove('loading');
      }, i * 50);
      // Apply click event listener on close button
      let closeButton = pill.querySelector('.close-btn');
      closeButton.addEventListener('click', e => {
        e.target.closest('.pill').classList.add('loading');
        // If this is the only pill
        if(appliedFilterPills.length <= 1) {
          window.location.href = urlRoot + 'collections/' + currentCollection + urlSortString; // Reload to collection with sort param but without tag params
        // Else create new tag string for URL
        } else {
          let tag = e.target.closest('.pill').getAttribute('data-tag');
          let newTagString = '/';
          Object.values(urlAllTags).forEach((urlTag, i) => {
            if(urlTag !== tag) {
              if(i > 0) {
                newTagString += ('+');
              }
              newTagString += urlTag;
            }
          });
          window.location.href = urlRoot + 'collections/' + currentCollection + newTagString + urlSortString;
        }
      });
    });
  }
  createFilterPills();



  var selectedTags = urlAllTags;
  var selectedTagsString = ''; // str

  // Compile selected tags string
  function makeTagsString(selectedTags) {
    selectedTagsString = ''; // Reset string
    if ($.isEmptyObject(selectedTags) == false) { // if tags object is not empty
      $.each(selectedTags, function(filterSection, tag){
        if (tag.indexOf(':all') == -1) { // only if tag doesn't contain ':all'
          selectedTagsString += tag + '+'; // append tag and '+'
        }
      });
      selectedTagsString = '/' + selectedTagsString.slice(0,-1); // Prepend '/' and trim last '+'
    }
    // console.log(selectedTagsString);
    // console.log(urlAllTags);
  }
  makeTagsString(selectedTags); // Call on load

  // Update selected tags
  function updateSelectedTags(selectedTag) {
    var selectedTagType = selectedTag;
    if (selectedTag.indexOf('stone:type:') >= 0) {
      selectedTagType = 'stone:type';
    } else if (selectedTag.indexOf('stone:shape:') >= 0) {
      selectedTagType = 'stone:shape';
    } else if (selectedTag.indexOf('stone:setting:') >= 0) {
      selectedTagType = 'stone:setting';
    } else {
      selectedTagType = selectedTag.split(':')[0];
    }
    selectedTags[selectedTagType] = selectedTag; // Modify the selected tags object
    makeTagsString(selectedTags); // Rewrite the selected tags string
  }



  // Disable incompatible options
  function disableIncompatibleOptions() {

    var allFilterOptionTags = [];
    var activeFilterOptionTags = [];
    $('.filter-option:not(.all)').each( function() { // exclude 'All' options
      allFilterOptionTags.push($(this).attr('data-tag')); // push all to array
      if ($(this).parent('li').hasClass('active')) {
        activeFilterOptionTags.push($(this).attr('data-tag')); // push only active to array
      }
    });

    var activeSiblingOptionTag = '';
    var activeFilterOptionTagCount = 0;
    var activeFilterOptionTagCountValid = 0;
    var allActiveFilterOptionTagsValid = false;

    // For each filter option
    for(var j = 0; j < allFilterOptionTags.length; j++) {

      // Find if there is an active filter option in the same section
      activeSiblingOptionTag = '';
      $(".filter-option[data-tag='" + allFilterOptionTags[j] + "']").closest('.filter-section').find('.filter-option:not(.all)').each( function() {
        if ($(this).parent('li').hasClass('active')) {
          activeSiblingOptionTag = $(this).attr('data-tag');
        }
      });

      allActiveFilterOptionTagsValid = false; // reset

      // Loop through all available products' tag strings
      for(var k = 0; k < availableProductAllTags.length; k++) {

        if (availableProductAllTags[k].indexOf(allFilterOptionTags[j]) >= 0) {

          activeFilterOptionTagCount = 0; // reset
          activeFilterOptionTagCountValid = 0; // reset

          // Check all active filter options
          for(var l = 0; l < activeFilterOptionTags.length; l++) {
            if (activeFilterOptionTags[l] !== activeSiblingOptionTag) { // exclude if is a sibling filter option
              activeFilterOptionTagCount += 1;
              if (availableProductAllTags[k].indexOf(activeFilterOptionTags[l]) >= 0) {
                activeFilterOptionTagCountValid += 1;
              }
            }
          } // end for
          if (activeFilterOptionTagCount == activeFilterOptionTagCountValid) {
            allActiveFilterOptionTagsValid = true; // All active filter options are in available products tags
          }

        } // end if has current filter option

      } // end for

      // Enable/disable current filter option
      if (allActiveFilterOptionTagsValid == false) {
        $(".filter-option[data-tag='" + allFilterOptionTags[j] + "']").parent('li').addClass('disabled');
      } else {
        $(".filter-option[data-tag='" + allFilterOptionTags[j] + "']").parent('li').removeClass('disabled');
      }

    } // end for

  } // end disableIncompatibleOptions()




  // Select filter item
  $('.filter-option').click( function() {
    $(this).parent().siblings('li').removeClass('active');
    $(this).parent('li').addClass('active');
    var thisItemTag = $(this).attr('data-tag');
    updateSelectedTags(thisItemTag); // Update selectedTagArray
    disableIncompatibleOptions(); // Disable options that are incompatible based on the current selection
    // Enable/disable Clear button depending on applied filters
    $('.filter-section').each( function() {
      if (!$(this).find('ul li.active').children('.all').length) {
        $('#filter-clear').removeClass('disabled');
        return false; // break
      } else {
        $('#filter-clear').addClass('disabled');
      }
    });
  });

  // Apply filters
  $('#filter-update').click( function() {
    window.location.href = urlRoot + 'collections/' + currentCollection + selectedTagsString + urlSortString;
    return false;
  });

  // Clear filters
  $('#filter-clear').click( function() {
    window.location.href = urlRoot + 'collections/' + currentCollection + urlSortString; // Reload to collection with sort param but without tag params
    return false;
  });

  //}




  var availableProductAllTags = [];

  // Create array of available product tag strings
  function getEachProductJSON(collectionProductsHandleArray) {
    let ajaxCounter = 0;
    for(var k = 0; k < collectionProductsHandleArray.length; k++) {
      var response = 'response' + k;
      ajaxCall('GET', window.location.protocol + '//' + window.location.hostname + '/products/' + collectionProductsHandleArray[k] + '.json', function(response){
        ajaxCounter += 1;
        var product = JSON.parse(response).product;
        const productTemplate = product.template_suffix || '';
        const productTagsToCheck = product.tags || '';
        if (productTemplate.indexOf('unavailable') < 0 && productTagsToCheck.indexOf('hidefromcollection') < 0 && productTagsToCheck.indexOf('availability:state:discontinued') === -1) {
          // Remove 'centre' and 'flank' stones to so that 'stone' tags are only used in cross references
          var productTags = product.tags;
          if (productTags.indexOf('centre-stone:') >= 0) {
            productTags = productTags.replaceAll("centre-stone:", "");
          }
          if (productTags.indexOf('flank-stone:') >= 0) {
            productTags = productTags.replaceAll("flank-stone:", "");
          }
          // Push tags string to array
          availableProductAllTags.push(productTags);
        }
        // If is last product
        if (ajaxCounter == collectionProductsHandleArray.length) {
          $('#filter-drawer').removeClass('loading'); // Allow interaction
          disableIncompatibleOptions(); // Disable options that are incompatible based on the current selection
        }
      });
    }
  }


  // Get array of product handles in collection
  function getCollectionProductsJSON() {
    var collectionProductsHandleArray = [];
    let ajaxPage = 0;
    for (let i = 0; i < totalCollectionProductPages; i++) {
      var page = i+1;
      ajaxCall('GET', window.location.protocol + '//' + window.location.hostname + '/collections/' + currentCollection + '/products.json?limit=' + ajaxMaxItems + '&page=' + page, function(response){
        ajaxPage += 1;
        let parsedResponse = JSON.parse(response); // Parse AJAX data
        let products = parsedResponse.products;
        for (let j = 0; j < products.length; j++){
          let productHandle = products[j].handle;
          collectionProductsHandleArray.push(productHandle);
          // If is last JSON page AND last product on that page
          if (ajaxPage == totalCollectionProductPages && j == products.length - 1) { // after last item AJAX is complete, so call function on array
            getEachProductJSON(collectionProductsHandleArray);
          }
        }

      });
    }
  }


  // Get total number of AJAX pages in collection (given the max of 250 products per request)
  var totalCollectionProductCount = document.getElementById('collection-top') ? document.getElementById('collection-top').getAttribute('data-collection-product-count') : document.getElementById('collection-premium-top').getAttribute('data-collection-product-count');
  var totalCollectionProductPages = Math.ceil(totalCollectionProductCount / ajaxMaxItems); // round up

  // Call on load
  $('#filter-drawer').addClass('loading'); // Block interaction until ready
  getCollectionProductsJSON();


} // end if is collection
